/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'vine': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" _fill="#01b488" d="M0 0h32v32H0V0z"/><path pid="1" _fill="#fff" d="M19.331 12.012c-.08-.641-.481-3.567 1.603-3.567s.922 4.649.922 4.649h3.482a9.983 9.983 0 00.405-2.886c0-3.767-2.685-5.09-4.569-5.09s-5.33.761-5.33 6.011 4.048 6.893 4.048 6.893c-1.082 2.405-3.847 5.37-3.847 5.37-5.05-5.691-5.731-15.028-5.731-15.028l-3.572.106c2.344 17.673 9.303 18.409 9.303 18.409 3.086-.51 7.013-8.015 7.013-8.015.641.08 2.605-.321 2.605-.321v-2.605c-5.25 1.162-6.252-3.286-6.332-3.927z"/>'
  }
})
